import React from "react";

import { ITabComponentV2Props, NewTabComponentV2 } from "./new-tab-v2";

interface IOverviewTabsWrapper extends ITabComponentV2Props {}

export const OverviewTabsWrapper = ({ tabs, switchButtons }: IOverviewTabsWrapper): JSX.Element => {
  return <NewTabComponentV2 switchButtons={switchButtons} tabs={tabs} />;
};
